@if (allocation) {
  <div
    class="border rounded-3 mb-2 overflow-hidden"
    style="border-left: 4px solid var(--allocation-main)"
    [ngClass]="includeHoverEffects ? 'voucher-allocation-card' : ''"
  >
    <div style="height: 14px; background-color: var(--allocation-main)"></div>
    <div class="p-3">
      <div class="d-flex justify-content-between align-items-center mb-1">
        <div class="d-flex align-items-center gap-2">
          <span class="fw-semibold fs-5">{{ allocation.programName }} - {{ allocation.distributionCycle.name }}</span>
        </div>
        <div class="d-flex align-self-start">
          <span class="badge" [ngClass]="statusClass">{{ allocation.distributionCycle.statusString }}</span>
        </div>
      </div>
      @if (allocation.distributionCycle.description) {
        <div class="fs-6 mb-1 fw-bold fst-italic">{{ allocation.distributionCycle.description }}</div>
      }
      <div class="small mb-1">
        Total Allocated Funds: <span class="fw-bold">{{ allocation.allocatedAmount | currency }}</span>
      </div>
      <div class="small mb-1">
        {{ allocation.distributionCycle.distributionTypeString }}, Distributed by
        {{ allocation.distributionCycle.distributedByString }}
      </div>

      <div class="small mb-2">
        {{ allocation.distributionCycle.startDate | date: 'M/d/yyyy' }} &ndash;
        {{ allocation.distributionCycle.endDate | date: 'M/d/yyyy' }}
      </div>
      @if (allocation.allocatedAmount > 0) {
        <div class="progress position-relative border border-primary" style="height: 20px">
          <div
            class="progress-bar progress-bar-primary-100"
            role="progressbar"
            [style.width.%]="creditsIssuedPct"
          ></div>
          <div
            class="progress-bar progress-bar-success-300 position-absolute top-0 start-0 h-100"
            role="progressbar"
            [style.width.%]="redeemedPct"
          ></div>
          <span
            class="position-absolute w-100 text-center fw-semibold text-primary"
            style="bottom: 5px; font-size: 0.9rem"
          >
            <span certTooltip="Redeemed Amount">{{ allocation.redeemedAmount | currency }}</span>
            /
            <span certTooltip="Assigned Amount">{{ allocation.creditsIssuedAmount | currency }}</span>
            /
            <span certTooltip="Unassigned Amount">{{ allocation.unassignedAmount | currency }}</span>
            <!-- The difference between allocated amount and assigned amount-->
          </span>
        </div>

        <!-- Row 4: Legend -->
        <div class="d-flex gap-3 mt-1 small">
          <span class="d-flex align-items-center gap-1">
            <span
              class="d-inline-block rounded-1 bg-success-300 border border-primary"
              style="width: 12px; height: 12px"
            ></span>
            Redeemed
          </span>
          <span class="d-flex align-items-center gap-1">
            <span
              class="d-inline-block rounded-1 bg-primary-100 border border-primary"
              style="width: 12px; height: 12px"
            ></span>
            Assigned
          </span>
          <span class="d-flex align-items-center gap-1">
            <span
              class="d-inline-block rounded-1 bg-light border border-primary"
              style="width: 12px; height: 12px"
            ></span>
            Unassigned
          </span>
        </div>
      }
    </div>
  </div>
} @else {
  <ngx-skeleton-loader count="2" />
}
